import { delay } from "../../../utils";
import { cardsAPI } from "../cardsAPI.ts";
import { IAddPaymentMethodResponse } from "../types.ts";

const POLL_INTERVAL_MS = 2000; // 2 сек
const MAX_TOTAL_TIME_MS = 60000; // 60 сек

export const addNewPaymentMethodMutation = async ({
  addMethod,
  signal,
}: {
  addMethod: (signal?: AbortSignal) => Promise<IAddPaymentMethodResponse>;
  signal: AbortSignal;
}): Promise<IAddPaymentMethodResponse> => {
  let response = await addMethod(signal);
  if (response.statusCode === "DONE") {
    return response;
  }

  if (response.statusCode !== "IN_PROGRESS") {
    throw new Error(`Unexpected status while adding a new payment method: ${response.statusCode}`);
  }

  const applicationId = response.id;
  if (!applicationId) {
    throw new Error("Application ID is undefined");
  }

  const pollingStartTime = Date.now();

  while (response.statusCode === "IN_PROGRESS") {
    const timePassed = Date.now() - pollingStartTime;

    if (timePassed > MAX_TOTAL_TIME_MS) {
      throw new Error("Failed getting redirectUrl in 60 seconds");
    }

    await delay(POLL_INTERVAL_MS);
    response = await cardsAPI.addPaymentMethodPolling({ id: applicationId, signal });
  }

  if (response.statusCode !== "DONE") {
    throw new Error(`Unexpected status after pooling a new payment method status: ${response.statusCode}`);
  }

  return response;
};
